export function getUserInfoFromSessionStorage() {
  const key = getStorageKey();
  const sessionStorageData = getSessionStorageData(key);
  const profile = sessionStorageData ? JSON.parse(sessionStorageData).profile : {};
  return {
    name: profile.name,
    username: profile.username,
    roles: getRolesFromProfile(sessionStorageData),
  };
}

function getRolesFromProfile(profile: string | null): string[] {
  if (profile) {
    const decodedProfileData = JSON.parse(profile);
    const roles = decodedProfileData.profile.role;
    return roles;
  }
  return [];
}

function getSessionStorageData(key: string) {
  const profile = window.sessionStorage.getItem(key);
  return profile;
}

function getStorageKey() {
  for (const key in window.sessionStorage) {
    if (key.includes("quattro.stacc")) {
      return key;
    }
  }

  return "";
}

export function getRolesFromSessionStorage(): string[] {
  const key = getStorageKey();
  const sessionStorageData = getSessionStorageData(key);
  return getRolesFromProfile(sessionStorageData) || [];
}

export function hasAccessRoles(userRoles: string[], overwriteAccessRoles?: string[]): boolean {
  const allowedRoles = overwriteAccessRoles ?? [
    "admin-se",
    "admin-es",
    "admin-no",
    "admin-fi",
    "admin-all",
    "reader-all",
  ];
  return allowedRoles.some((role) => userRoles.includes(role));
}

export function isReaderOnly(userRoles: string[]): boolean {
  const canCompleteRoles = [
    "admin-se",
    "admin-es",
    "admin-no",
    "admin-fi",
    "admin-all",

    "caseworker-se",
    "caseworker-es",
    "caseworker-no",
    "caseworker-fi",
  ];
  return !canCompleteRoles.some((role) => userRoles.includes(role));
}
